export default __webpack_public_path__ + "static/media/icons8-traveler-100.1b58093d.svg";